import React, { useEffect, useState } from "react";
import "./style.css";
import {
  Layout,
  Empty,
  Breadcrumb,
  Table,
  Button,
  Space,
  Input,
  Row,
  Col,
  Modal,
  Spin,
  Tabs,
} from "antd";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { DownloadOutlined, SyncOutlined, WarningTwoTone } from "@ant-design/icons";
import Container from "../../Layout/Container";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getViewAllProcess, getRejectStage, DDsAndAdsTakeActionNotySelector, clearState, takeActionAsyn, clearStateRejectStage } from './DDsAndAdsTakeActionNotySlice';
import moment from 'moment';
import { authSelector } from '../../Auth/authSlice';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const ntop = "none";
const nbottom = "bottomCenter";



export default function TakeActionNotification() {

  const dispatch = useDispatch();
  const location = useLocation();
  let history = useHistory();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [processRecord, setprocessRecord] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { isFetching, isAllprocessSuccess, isRejectStageSuccess, isError, errorMessage, allProcessData, processTimeLogs, signed, docPathname } = useSelector(
    DDsAndAdsTakeActionNotySelector
  );

  const { isLoggedIn, isGoogleSignIn, user } = useSelector(
    authSelector
  );

  useEffect(() => {
    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(getViewAllProcess(location.state.processId));
  }, []);

  useEffect(() => {

    if (isError) {
      setprocessRecord([]);
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);
      dispatch(clearState());
    }
    if (isAllprocessSuccess) {
      setLoading(false);
      setprocessRecord(allProcessData);
    }
    if (isRejectStageSuccess) {
      setLoading(false);
      setIsModalVisible(false);
      setToast(true);
      toast.success(errorMessage);
      history.push('/view-all-notification');
      dispatch(clearStateRejectStage());
    }

  }, [isError, isAllprocessSuccess, isRejectStageSuccess, setLoading, allProcessData, processTimeLogs, signed, docPathname]);


  const data = [
    {
      id: 1,
      process_action: "Process Initiated",
      action_taken_by: "Homer Ryan",
      type: "Clerk",
      date_time: "11 Jun 2021, 11:43PM",
      doc_changes: "Uploaded",
      comments: "No",
    },
    {
      id: 2,
      process_action: "Stage 1",
      action_taken_by: "Mark Joe",
      type: "Officer",
      date_time: "11 Jun 2021, 11:43PM",
      doc_changes: "Signed",
      comments: "No",
    }

  ];

  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    return obj;
  };

  const columns = [
    {
      title: "Process Action",
      dataIndex: "process_action",
      render: renderContent,
    },
    {
      title: "Action Taken by",
      dataIndex: "action_taken_by",
      render: renderContent,
    },
    {
      title: "Type",
      dataIndex: "type",
      render: renderContent,
    },
    {
      title: "Date & Time",
      dataIndex: "date_time",
      render: renderContent,
    },
    {
      title: "Doc Changes",
      dataIndex: "doc_changes",
      render: (text, row, index) => {
        return {
          children: <p className="mar-b-0 process-time-log-docs"><span>{text}</span>
            {/* <Link to={row.dwnFile} target="_blank" download><DownloadOutlined /></Link> */}
            {row.doc_changes != "No"
              && <a href={row.dwnFile} download="My_File" target='_blank' style={{ color: 'rgb(37, 55, 217)', fontSize: 18 }} className="mar-l-10"><DownloadOutlined /></a>
            }
          </p>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: "Comments",
      dataIndex: "comments",
      render: renderContent,
    },
  ];

  const handleViewDocumentSeenStamp = (row) => {
    // console.log("click", row.processId);
    if (row.processId) {
      //console.log("Send-data to verify-document => ", values.documentDetail.processId)
      let takeAction = dispatch(takeActionAsyn(row.processId)).then((res) => {
        // console.log('res', res)
        history.push({
          pathname: '/verify-document2',
          // search: '?query=abc',
          state: { documentInfo: res.data, processId: row.processId, viewDocument: true, }
        });
      });
    }

  }


  const handleStatusApprovedDelay = (record) => {

    var status = "";
    var msg = "";

    if (record && record.isSigned === true) {
      status = "text-color-success mar-t-15 font-17";
      msg = "Signed";
    }
    else {
      status = "text-color-danger mar-t-15 font-17";
      msg = "Not signed"
    }


    var result = {
      status: status,
      msg: msg,
    };

    return result;

  }

  // const handleStatusApprovedDelay = (record) => {

  //   var status = "";
  //   var msg = "";
  //   var final = 406;
  //   var respondWithin = 0; // sign kitne time tak karna tha.. 
  //   var responseTime = record && record.responseTime != null ? moment(record.responseTime) : 0; // sign kab kiya ..

  //   if (record && record.isSigned === true) {

  //     var timeArray = record && record.signWithin && record.signWithin.time.split(':').map(a => a.split(','));

  //     if (timeArray != undefined && record && record.signWithin && record.signWithin.day && record.signWithin.day != undefined) {
  //       respondWithin = moment().add(record.signWithin.day, "days").add(parseInt(timeArray[0]), 'hours').add(parseInt(timeArray[1]), 'minutes').add(parseInt(timeArray[2]), 'seconds'); // kitne der me karna h usko task , time frame me ..
  //       // console.log("timeArray[0]", parseInt(timeArray[0]))
  //     }

  //     console.log("respondWithin", respondWithin);
  //     console.log("responseTime", responseTime);

  //     if (respondWithin != 0 && responseTime != 0) {
  //       final = moment(respondWithin).diff(moment(responseTime), "minutes");
  //     }

  //     if (final >= 0 && final != 406) {
  //       status = "text-color-success mar-t-15 font-17";
  //       msg = "Approved on time";
  //     } else if (final < 0) {
  //       var min = parseInt(final % 60);
  //       var hours = parseInt(final / 60);
  //       var days = parseInt(hours / 24);
  //       hours = hours - 24 * days;
  //       status = "text-color-danger mar-t-15 font-17";
  //       msg = "Delayed by " + days + " days " + hours + " hours " + min + " min";
  //     }
  //     else if (final === 406) {
  //       status = "text-color-warning mar-t-15 font-17";
  //       msg = "Signed not done yet";
  //     }
  //     console.log('finaltime ', final);
  //   }
  //   else {
  //     status = "text-color-warning mar-t-15 font-17";
  //     msg = "Signed not done yet";
  //   }

  //   var result = {
  //     status: status,
  //     msg: msg,
  //   };

  //   return result;

  // }


  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleConfirm = (e, row) => {
    e.preventDefault();
    // console.log(row);
    var data = {
      "doc_id": row._id
    }
    dispatch(getRejectStage(data));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };



  let dataSource = isLoading
    ? []
    : processTimeLogs && processTimeLogs.length > 0 ? processTimeLogs.map(row => ({
      id: row._id,
      process_action: row.processAction,
      action_taken_by: row.actionTokenBy,
      type: row.type,
      date_time: moment(row.addedOn).format("lll"),
      doc_changes: row.isStatus,
      dwnFile: docPathname + row.pdfFile,
      comments: row && row.isComment && row.isComment === true ? "Yes" : "No",
    })) : [];

  return (
    <>
      <Container>
        <Breadcrumb style={{ backgroundColor: '#f3f8ff', padding: '26px 50px' }} separator=">">
          <Breadcrumb.Item><Link to="/dashboard">Dashboard</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Notification</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-content"
          style={{ paddingTop: 0 }}
        >
          <div>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <Space
              style={{
                // padding: 16,
                width: "100%",
                // borderLeft: "1px solid #dfe0eb",
                // borderRight: "1px solid #dfe0eb",
              }}
              size="large"
            >
              <Row style={{ width: "100%" }}>
                <Col span="8" className="bg-fbfbfb pad-40" style={{ borderRight: 'solid 2px #f1f1f1' }}>
                  <h1 className="mar-b-30" style={{ fontWeight: "600", color: "#292c40", fontSize: "23px" }}>
                    <img src="./images/pdficon.png" style={{ width: "45px" }} />
                    &nbsp; Recuritment Request
                  </h1>
                  <Row>
                    <Col span="12">
                      <p className="text-color-6b778c mar-b-5">Process ID</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.processId ? processRecord.processId : 'N/A'}</p>

                      <p className="text-color-6b778c mar-b-5">Download Restricted</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.restrictDownload && processRecord.restrictDownload === true ? "Yes" : "No"}</p>

                      <p className="text-color-6b778c mar-b-5">Times Document Signed</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.signCount || processRecord.signCount === 0 ? processRecord.signCount : "N/A"}</p>
                    </Col>
                    <Col span="12" className="text-right">
                      <p className="text-color-6b778c mar-b-5">Added On</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.addedOn ? moment(processRecord.addedOn).format("ll") : "N/A"}</p>

                      <p className="text-color-6b778c mar-b-5">Document Type</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.documentType ? processRecord.documentType : "N/A"}</p>

                      <p className="text-color-6b778c mar-b-5">Recived From</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.receivedFrom ? processRecord.receivedFrom : "N/A"}</p>
                    </Col>
                  </Row>

                  <Row>

                    <Col span="23">
                      <p className="text-color-6b778c mar-b-5">Subject</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.processSubject ? processRecord.processSubject : "N/A"}</p>

                    </Col>
                    <Col span="1"></Col>
                  </Row>

                </Col>
                <Col span="16" className="bg-fbfbfb pad-40 #f1f1f1">

                  <Row>
                    <Col className="mar-b-25" span="12" style={{ textAlign: "Left" }}>
                      <h1 className="font-24" style={{ fontWeight: "600", color: "#292c40" }}>Process Flow</h1>
                    </Col>
                    <Col span="12" style={{ textAlign: "right" }}>
                      <Space>
                        <Button
                          size="large"
                          style={{
                            borderRadius: 5,
                            padding: "3px 8px",
                            fontWeight: 600,
                            fontSize: 14,
                            height: '35px',
                          }}
                          onClick={(e) => handleViewDocumentSeenStamp(processRecord)}
                          type="primary"
                        >
                          View Document & Seen Stamp
                        </Button>
                      </Space>

                    </Col>
                  </Row>

                  {signed && signed.length > 0 ?

                    signed.map(function (row, item) {
                      // var str = 'Bob,1234,Bob@example.com;Mark,5678,Mark@example.com',
                      var timeArray = row && row.isSigned === true && row.signWithin && row.signWithin.time.split(':').map(a => a.split(','));

                      return (
                        <>
                          <div className="mar-b-30" key={item}>
                            <h5 style={{ color: "#2537d9", fontWeight: "500" }} className="font-16 mar-b-20">Stage {row && row.stage}</h5>
                            <Space
                              style={{
                                padding: 16,
                                width: "100%",
                                backgroundColor: "#ffffff"
                              }}
                              size="large"
                            >
                              <Row>
                                <Col span="7">

                                  <p className="text-color-6b778c mar-b-5">User type</p>
                                  <p className="font-16 mar-b-0">{row && row.detailedUser && row.detailedUser.userType ? row.detailedUser.userType : "N/A"}</p>

                                </Col>
                                <Col span="2"></Col>
                                <Col span="7">

                                  <p className="text-color-6b778c mar-b-5">Assigned to</p>
                                  <p className="font-16 mar-b-0 single-line-text-dot" style={{ paddingRight: "15px" }}>{row && row.detailedUser && row.detailedUser.fullName ? row.detailedUser.fullName : "N/A"}</p>
                                </Col>
                                <Col span="1">

                                  {/* <p className="text-color-6b778c mar-b-5">Approved </p>
                                  <p className="font-16 mar-b-0">{row && row.responseTime != null ? moment(row.responseTime).format("ll") : "N/A"}</p> */}
                                </Col>
                                <Col span="7" style={{ padding: 20 }}>

                                  {/* <p className="text-color-danger mar-t-15 font-17">Delayed by 2 hours</p> */}
                                  {
                                    row && row.isSigned === true
                                      ? <p className={handleStatusApprovedDelay(row).status}>{handleStatusApprovedDelay(row).msg}</p>
                                      : user && user.username === row.username
                                        ?
                                        <>
                                          <Button type="text" onClick={showModal} danger style={{ paddingRight: 30 }}>
                                            Reject
                                          </Button>
                                          <Button type="primary"
                                            onClick={(e) => handleViewDocumentSeenStamp(processRecord)}
                                            style={{
                                              borderRadius: 5,
                                              padding: "3px 8px",
                                              fontWeight: 600,
                                              fontSize: 14,
                                              height: '35px',
                                            }}>
                                            Approve
                                          </Button>
                                        </>
                                        : (<p className={handleStatusApprovedDelay(row).status}>{handleStatusApprovedDelay(row).msg}</p>)
                                  }

                                </Col>
                              </Row>

                            </Space>
                          </div>
                        </>
                      );
                    })
                    :
                    (
                      <div className="mar-b-30">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      </div>
                    )

                  }


                  <h1
                    style={{
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: 22,
                      color: "#292c40",
                      marginBottom: 12,
                      marginTop: 15,
                    }}
                  >
                    Process Time Log
                  </h1>
                  <Table
                    columns={columns}
                    pagination={false}
                    // pagination={{
                    //   position: [ntop, nbottom],
                    //   size: "small",
                    //   defaultPageSize: 8,
                    //   hideOnSinglePage: true,
                    // }}
                    dataSource={dataSource}
                    bordered

                    className="white-space-nowrap mytablecss"
                  />

                </Col>
              </Row>
            </Space>

          </div>
        </div>

        {/* Reject Modal code start here ... */}

        <Modal className="reject-modal-css" centered width={700} okButtonProps={{ style: { display: 'none' } }} title="" visible={isModalVisible} onCancel={handleCancel}
          footer={[
            <Button type="primary" size="large" ghost onClick={handleCancel}>Cancel</Button>,
            <Button key="submit" type="primary" size="large" style={{ marginLeft: 18 }} onClick={(e) => handleConfirm(e, processRecord)}>
              Confirm
            </Button>,

          ]}

        >
          <Row>
            <Col span="12">

              <h1><WarningTwoTone twoToneColor="#f81d22" style={{ fontSize: 30 }} /><span style={{ paddingLeft: 16, fontWeight: 600 }}>Alert</span></h1>
            </Col>
            <Col span="12"></Col>
            <p style={{ fontSize: 20, paddingLeft: 2 }}>Are you sure you want to reject this process? When you reject this process it will result in sending this process back to (Last_Receiver) for review!</p>
          </Row>
        </Modal>


      </Container>
    </>
  );
}
